import { format } from 'date-fns';
import { enUS, vi } from 'date-fns/locale';

function formatDate(date, locale, fmt) {
  if (!date) {
    date = Date.now();
  }
  return format(!(date instanceof Date) ? new Date(date) : date, fmt || "HH:mm, EEEE dd/MM/yyyy", {
    locale: locale === "en" ? enUS : vi
  });
}

export { formatDate };
